<!-- Facebook Feed (mobile) -->
<div class="fbp">
  <div class="fbp-header">
    <img class="fbp-avatar" [src]="avatar" alt="" />
    <div class="fbp-identity">
      <div class="fbp-name">{{ pageName }}<i class="bi bi-patch-check-fill fbp-verified"></i></div>
      <div class="fbp-meta">Oglas · <i class="bi bi-globe-americas"></i></div>
    </div>
    <div class="fbp-header-icons">
      <i class="bi bi-three-dots"></i>
      <i class="bi bi-x-lg"></i>
    </div>
  </div>

  <div class="fbp-text">{{ primaryText.text }}</div>
  <div class="fbp-more" *ngIf="primaryText.truncated">...Prikaži više</div>

  <a class="fbp-link" [attr.href]="data.url || null" target="_blank" rel="noopener noreferrer">
    <app-meta-creative [src]="data.creative" [kind]="data.creativeKind" slot="feed"></app-meta-creative>
    <div class="fbp-cta-bar">
      <div class="fbp-cta-copy">
        <div class="fbp-headline">{{ headline }}</div>
      </div>
      <span class="fbp-cta">{{ cta }}</span>
    </div>
  </a>

  <div class="fbp-reactions">
    <span class="fbp-like-badge"><i class="bi bi-hand-thumbs-up-fill"></i></span>
    <span>26</span>
  </div>

  <div class="fbp-actions">
    <span class="fbp-action"><i class="bi bi-hand-thumbs-up"></i>Sviđa mi se</span>
    <span class="fbp-action"><i class="bi bi-chat"></i>Komentiraj</span>
    <span class="fbp-action"><i class="bi bi-reply fbp-share-icon"></i>Podijeli</span>
  </div>
</div>
